export default __webpack_public_path__ + "3d60ee2da730e329c9a5a77c394f959a.png";